<template>
  <div class="setup-footer">
    <div class="background--branded">
      <div class="container">
        <div v-if="hasUnderlinedFooterLinks"
             class="row text-center spacing-3 no-gutters">
          <div class="col-auto">
            <span v-for="(footerLink, index) in underlinedFooterLinks"
                  :key="index">
              <span class="ml-2 mr-1 text-white">
                {{ index !== 0 ? '|' : ''}}
              </span>
              <a :href="footerLink.linkUrl"
                 class="text-white text-underline"
                 role="link"
                 target="_blank"
                 tabindex="0">
                {{ footerLink.label }}
              </a>
            </span>
          </div>
        </div>

        <div class="row justify-content-md-center">
          <div v-for="(footerLink, index) in footerLinksData"
               :key="index"
               class="col-md-auto col-6 px-5 px-md-3 spacing-3">
            <a :href="footerLink.linkUrl"
               class="text-white"
               role="link"
               target="_blank"
               tabindex="0">
              {{ footerLink.label }}
            </a>
          </div>
        </div>

        <div class="row spacing-3 text-center">
          <div class="col text-white">
            {{ config.copyrightStatement }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="hasFooterConfig"
         class="container">
      <div class="row spacing-3">
        <div class="col"
             :class="footerTextSize">
          <span v-for="(item, index) in footerText"
                :key="index"
                :class="getStyles(item)">
            <a v-if="item.isLink"
               tabindex="0"
               role="link"
               class="text-link"
               :class="footerTextSize"
               target="_blank"
               :href="item.url">
              {{ item.text }}
            </a>
            <span v-else>
              {{ item.text }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Libraries
import { mapGetters, mapState } from 'vuex'

// Utilities
import isEmpty from '../../../utility/isEmpty.js'

export default {
  name: 'setup-footer',

  computed: {
    hasFooterLinks () {
      return !isEmpty(this.config?.footerLinks)
    },

    hasFooterConfig () {
      return !isEmpty(this.config?.footerConfig)
    },

    hasUnderlinedFooterLinks () {
      return !isEmpty(this.underlinedFooterLinks)
    },

    underlinedFooterLinks () {
      return this.config?.underlinedFooterLinks ?? []
    },

    footerLinksData () {
      if (!this.hasFooterLinks) {
        return []
      }

      return this.config.footerLinks
    },

    footerConfig () {
      if (!this.hasFooterConfig) {
        return []
      }

      return this.config.footerConfig
    },

    footerText () {
      return this.hasFooterConfig && !isEmpty(this.footerConfig.footerText) ? this.footerConfig.footerText : []
    },

    footerTextSize () {
      return this.hasFooterConfig && !isEmpty(this.footerConfig.footerTextSize) ? `text-${this.footerConfig.footerTextSize}` : 'text-12'
    },

    ...mapGetters('offers', ['getStyles']),
    ...mapState('applicationSession', ['config'])
  }
}
</script>

<style scoped lang="scss">
@use '../../../assets/styles/colors';

.setup-footer {
  .container {
    max-width: 56.25rem;
    padding: 1rem 1rem 2rem 1rem;
    margin-bottom: 0;
  }
}

.background--branded {
  .c1l & {
    background-color: colors.$c1l--green-8;
  }

  .ccc & {
    background-color: colors.$ccc--blue-2;
  }

  .ccf & {
    background-color: colors.$ccf--blue-1;
  }

  .chs & {
    background-color: colors.$chs--green-6;
  }

  .cic & {
    background-color: colors.$cic--blue-2;
  }

  .esm & {
    background-color: colors.$esm--green-1;
  }

  .inl & {
    background-color: colors.$inl--blue-4;
  }

  .tbs & {
    background-color: colors.$tbs--purple-1;
  }

  .tmx & {
    background-color: colors.$tmx--blue-8;
  }
}

.d-block {
  min-height: 1rem;
}
</style>
